import {differenceInCalendarDays, parseISO} from 'date-fns';

/**
 * Counts **UTC calendar-day boundaries crossed**, not complete elapsed 24-hour periods. No timezone
 * is modelled on tenant, branch or user, so every interest threshold is expressed in UTC calendar
 * days. `date-fns` compares calendar dates in the runtime timezone, so each timestamp is first
 * rebuilt from its UTC year/month/day components; the result is therefore independent of where the
 * code runs.
 *
 * The distinction is load-bearing: 23:30 → 00:30 the next day is 1 day here, and 0 under elapsed
 * semantics. Using elapsed days makes `goingCold` and `overdueBySinceDays` fire up to a day late.
 */
const toUtcCalendarDate = (timestamp: string) => {
  const parsedTimestamp = parseISO(timestamp);

  // eslint-disable-next-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible
  return new Date(
    parsedTimestamp.getUTCFullYear(),
    parsedTimestamp.getUTCMonth(),
    parsedTimestamp.getUTCDate()
  );
};

export const differenceInWholeDays = (laterAt: string, earlierAt: string) =>
  differenceInCalendarDays(toUtcCalendarDate(laterAt), toUtcCalendarDate(earlierAt));
